// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1D_fs","footer":"ChangeClinic_footer__Wf6V9"};